import styled from "@emotion/styled";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useBreakpoint } from "@avenue-8/sidekick-ui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const BreadcrumbTitle = styled(Typography)`
  font-family: ${(p) => p.theme.title.fonts.primary};
  font-size: ${(p) => p.theme.title.fontSizes.h6};
  font-weight: 500;
  cursor: default;
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
  }

  ${(p) => p.theme.media.mobileDown} {
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }
`;

export type PageBreadcrumbsProps = {
  current: {
    label: string;
    link?: string;
  };
  previous?: {
    label: string;
    link: string;
  }[];
};

export const PageBreadcrumbs = (props: PageBreadcrumbsProps) => {
  const { current, previous } = props;
  const isMobile = useBreakpoint("mobile");
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 2 }}>
      {!isMobile &&
        previous?.map((item) => (
          <BreadcrumbTitle key={`key-${item.link}`}>
            <Link to={item.link}>{item.label}</Link>
          </BreadcrumbTitle>
        ))}
      {isMobile && previous?.length && (
        <BreadcrumbTitle key={`key-${previous[previous.length - 1].link}`}>
          <Link to={previous[previous.length - 1].link}>
            <ArrowBackIcon />
          </Link>
        </BreadcrumbTitle>
      )}
      <BreadcrumbTitle>
        {current.link ? (
          <Link to={current.link}>{current.label}</Link>
        ) : (
          current.label
        )}
      </BreadcrumbTitle>
    </Breadcrumbs>
  );
};
